import { Link } from "react-router-dom";
import { Clock3, Mail, MapPin, Phone } from "lucide-react";
import { CONTACT, NAV_LINKS } from "@/data/site";

export const Footer = () => (
  <footer className="bg-brand-navy text-brand-cream" data-testid="site-footer">
    <div className="section-shell grid gap-12 py-16 lg:grid-cols-[1.3fr_0.7fr_1fr] lg:py-24">
      <div>
        <div className="mb-6 flex items-center gap-3">
          <span className="grid h-14 w-14 place-items-center rounded-lg bg-brand-copper font-serif text-3xl font-black text-brand-navy">E</span>
          <div>
            <p className="font-serif text-3xl font-black tracking-tight">Egaal</p>
            <p className="mt-1 text-sm font-extrabold uppercase tracking-[0.16em] text-brand-cream/68">Tax & Immigration Services</p>
          </div>
        </div>
        <p className="max-w-md text-sm leading-7 text-brand-cream/72">
          Helping individuals and families navigate U.S. immigration document preparation with clarity, confidentiality, and personalized support.
        </p>
        <p className="mt-8 max-w-xl border-l-2 border-brand-copper pl-4 text-xs leading-6 text-brand-cream/58">
          Egaal Tax & Immigration Services is not a law firm and does not provide legal advice or representation. Immigration document preparation and administrative support are provided; complex legal matters may require a licensed immigration attorney.
        </p>
      </div>
      <div>
        <h3 className="overline mb-6 text-brand-copper">Pages</h3>
        <nav className="flex flex-col gap-3" aria-label="Footer navigation">
          {NAV_LINKS.map((link) => (
            <Link
              key={link.href}
              to={link.href}
              data-testid={`footer-link-${link.label.toLowerCase().replaceAll(" ", "-")}`}
              className="text-sm font-semibold text-brand-cream/72 transition-colors duration-300 hover:text-brand-copper"
            >
              {link.label}
            </Link>
          ))}
        </nav>
      </div>
      <div>
        <h3 className="overline mb-6 text-brand-copper">Contact</h3>
        <div className="space-y-4 text-sm text-brand-cream/76">
          <a href={CONTACT.phoneHref} data-testid="footer-phone-link" className="flex gap-3 transition-colors hover:text-brand-copper">
            <Phone className="mt-0.5 h-4 w-4 text-brand-copper" /> {CONTACT.phone}
          </a>
          <a href={CONTACT.emailHref} data-testid="footer-email-link" className="flex gap-3 break-all transition-colors hover:text-brand-copper">
            <Mail className="mt-0.5 h-4 w-4 shrink-0 text-brand-copper" /> {CONTACT.email}
          </a>
          <p className="flex gap-3">
            <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-brand-copper" /> {CONTACT.address}
          </p>
          <p className="flex gap-3">
            <Clock3 className="mt-0.5 h-4 w-4 shrink-0 text-brand-copper" /> Mon, Tue, Thu, Fri & Sat · 3 PM – 9 PM
          </p>
        </div>
      </div>
    </div>
    <div className="border-t border-white/10 py-6 text-center text-xs text-brand-cream/50">
      © 2026 Egaal Tax & Immigration Services. All rights reserved.
    </div>
  </footer>
);
